import { render, staticRenderFns } from "./PostLinkedin.vue?vue&type=template&id=dbb4a88c"
import script from "./PostLinkedin.vue?vue&type=script&lang=js"
export * from "./PostLinkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb4a88c')) {
      api.createRecord('dbb4a88c', component.options)
    } else {
      api.reload('dbb4a88c', component.options)
    }
    module.hot.accept("./PostLinkedin.vue?vue&type=template&id=dbb4a88c", function () {
      api.rerender('dbb4a88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PostLinkedin.vue"
export default component.exports